import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ShareSchemeService {

  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService,
    private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getAll(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `sharescheme?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'server error')),
    );
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'sharescheme/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `sharescheme/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computeAdditionalFees(schemeId: number, sharesPurchased: number, collectApplicationAdmissionAndOtherFees: boolean ): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `sharescheme/compute/${schemeId}?sharesPurchased=${sharesPurchased}
                     &&collectApplicationAdmissionAndOtherFees=${collectApplicationAdmissionAndOtherFees}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(shareScheme: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'sharescheme', shareScheme).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'server error')),
    );
  }

  update(shareScheme: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'sharescheme', shareScheme).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'sharescheme/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'server error')),
    );
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `sharescheme/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
